// extracted by mini-css-extract-plugin
export default {"container":"ViewPolicies_container__oG0UD","header":"ViewPolicies_header__x0zcc","searchRow":"ViewPolicies_searchRow__+jP66","active":"ViewPolicies_active__n5mxM"};